import weapons01 from "../images/equipment/weapons01.png";
import weapons02 from "../images/equipment/weapons02.png";
import weapons03 from "../images/equipment/weapons03.png";
import weapons04 from "../images/equipment/weapons04.png";
import weapons05 from "../images/equipment/weapons05.png";
import weapons06 from "../images/equipment/weapons06.png";
import weapons07 from "../images/equipment/weapons07.png";
import weapons08 from "../images/equipment/weapons08.png";
import weapons09 from "../images/equipment/weapons09.png";
import weapons10 from "../images/equipment/weapons10.png";
import headgears01 from "../images/equipment/headgears01.png";
import headgears02 from "../images/equipment/headgears02.png";
import headgears03 from "../images/equipment/headgears03.png";
import headgears04 from "../images/equipment/headgears04.png";
import headgears05 from "../images/equipment/headgears05.png";
import headgears06 from "../images/equipment/headgears06.png";
import headgears07 from "../images/equipment/headgears07.png";
import headgears08 from "../images/equipment/headgears08.png";
import headgears09 from "../images/equipment/headgears09.png";
import face00 from "../images/equipment/face00.png";
import face01 from "../images/equipment/face01.png";
import face02 from "../images/equipment/face02.png";
import face03 from "../images/equipment/face03.png";
import face04 from "../images/equipment/face04.png";
import face05 from "../images/equipment/face05.png";
import face06 from "../images/equipment/face06.png";
import pets01 from "../images/equipment/pets01.png";
import pets02 from "../images/equipment/pets02.png";
import pets03 from "../images/equipment/pets03.png";
import pets04 from "../images/equipment/pets04.png";
import pets05 from "../images/equipment/pets05.png";
import pets06 from "../images/equipment/pets06.png";
import cloaks01 from "../images/equipment/cloaks01.png";
import cloaks02 from "../images/equipment/cloaks02.png";
import cloaks03 from "../images/equipment/cloaks03.png";
import cloaks03_1 from "../images/equipment/cloaks03-1.png";
import cloaks04 from "../images/equipment/cloaks04.png";
import cloaks05 from "../images/equipment/cloaks05.png";
import cloaks06 from "../images/equipment/cloaks06.png";
import wafers01 from "../images/equipment/wafers01.png";
import wafers02 from "../images/equipment/wafers02.png";
import wafers03 from "../images/equipment/wafers03.png";
import wafers04 from "../images/equipment/wafers04.png";
import wafers05 from "../images/equipment/wafers05.png";
import wafers06 from "../images/equipment/wafers06.png";
import background01 from "../images/equipment/background01.png";
import background02 from "../images/equipment/background02.png";
import background03 from "../images/equipment/background03.png";
import background04 from "../images/equipment/background04.png";
import canvasBg01 from "../images/equipment/canvas_bg01.png";
import canvasBg02 from "../images/equipment/canvas_bg02.png";
import canvasBg03 from "../images/equipment/canvas_bg03.png";
import canvasBg04 from "../images/equipment/canvas_bg04.png";
import canvasBgSmall01 from "../images/equipment/canvas_bg_small01.png";
import canvasBgSmall02 from "../images/equipment/canvas_bg_small02.png";
import canvasBgSmall03 from "../images/equipment/canvas_bg_small03.png";
import canvasBgSmall04 from "../images/equipment/canvas_bg_small04.png";

const images = {
  weapons01,
  weapons02,
  weapons03,
  weapons04,
  weapons05,
  weapons06,
  weapons07,
  weapons08,
  weapons09,
  weapons10,
  headgears01,
  headgears02,
  headgears03,
  headgears04,
  headgears05,
  headgears06,
  headgears07,
  headgears08,
  headgears09,
  face00,
  face01,
  face02,
  face03,
  face04,
  face05,
  face06,
  pets01,
  pets02,
  pets03,
  pets04,
  pets05,
  pets06,
  cloaks01,
  cloaks02,
  cloaks03,
  cloaks03_1,
  cloaks04,
  cloaks05,
  cloaks06,
  wafers01,
  wafers02,
  wafers03,
  wafers04,
  wafers05,
  wafers06,
  background01,
  background02,
  background03,
  background04,
  canvasBg01,
  canvasBg02,
  canvasBg03,
  canvasBg04,
  canvasBgSmall01,
  canvasBgSmall02,
  canvasBgSmall03,
  canvasBgSmall04,
};

export default images;
